<script>
  import {push} from 'svelte-spa-router';

  const url = `/ianua/user/login`;

  let _err = '';
  let username = '';
  let password = '';
  
  async function login(){
    // https://web.dev/articles/fetch-api-error-handling
    // https://dev.to/dionarodrigues/fetch-api-do-you-really-know-how-to-handle-errors-2gj0
    let json;

    if (username === "") {
      return;
    }
    
    const data = new FormData();
    data.append('username', username);
    data.append('password', password);
    
    try {
      const res = await fetch(url, {
	method: 'POST',
	body: data,
      });
      if (res.ok) {
	json = await res.json();
      } else {
	if (res.status === 401) throw new Error('Invalid credential');
	if (res.status === 404) throw new Error('Not found');
	throw new Error(res.status);
      }
    } catch(err) {
      _err = err;
    };

    if(json) {
      push('/home');
    }
  };

  function reset() {
    _err = '';
    username = '';
    password = '';    
    return;
  };

  
  // OK
  /* async function login(){
   *   fetch(url, {
   *     method: 'POST',
   *     body: user,
   *   })
   *     .then((res) => {
     if (res.status == 200) {
     push('/');
     } else {
     _err = true;
     }
   *     });
   * }; */
  
</script>

<div id="main" class="wrapper style1">
  <div class="container">
    <section id="content">
      
      <form>
	<div class="row gtr-uniform gtr-50">
	  <div class="col-3"> </div>
	  <div class="col-6 col-12-xsmall">
	    <label for="username" class="text120">Username:</label>
	    <input bind:value="{username}" type="text" name="username" id="username" placeholder="Username" />
	  </div>
	  <div class="col-3"> </div>
	  <div class="col-3"> </div>
	  <div class="col-6 col-12-xsmall">
	    <label for="password" class="text120">Password:</label>
	    <input bind:value="{password}" type="password" name="password" id="email" placeholder="Password" />
	  </div>
	  <div class="col-3"> </div>
	  <div class="col-3"> </div>
	  <div class="col-6 col-12-xsmall">
	    <ul class="actions">
	      <li><input on:click|preventDefault="{login}" type="submit" value="Invia" class="primary" /></li>
	      <li><input on:click|preventDefault="{reset}" type="reset" value="Reset" /></li>
	    </ul>
	  </div>
	</div>
      </form>
      {#if _err}
	<div class="row gtr-uniform gtr-50">
	  <div class="col-3"> </div>
	  <div class="col-6 col-12-xsmall">
	    <div class="center">
	      <strong class="warning">{_err}</strong>
	    </div>
	  </div>
	</div>
      {/if}
    </section>

  </div>
</div>
